var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  style: {
    width: 24,
    height: 24
  },
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17 3a2 2 0 012 2v16l-7-3-7 3V5a2 2 0 012-2h10m-6 11l6.25-6.24-1.41-1.42L11 11.18 8.41 8.59 7 10l4 4z"
})));

export default SvgIcon;